import { render, staticRenderFns } from "./TablePricesComponent.vue?vue&type=template&id=f082e380"
import script from "./TablePricesComponent.vue?vue&type=script&lang=js"
export * from "./TablePricesComponent.vue?vue&type=script&lang=js"
import style0 from "./TablePricesComponent.vue?vue&type=style&index=0&id=f082e380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports